module.exports = __webpack_public_path__ + "img/qq7.30f1893c.jpg";